import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const visualizationApi = async () => {
  try {
    const apiLink = `${endpoint}/api/visualization`;
    const response = await axios.get(apiLink);
    const data = response.data;

    const dataArray = [];
    if (data) {
      data.forEach((elem) => {
        const obj = {
          id: elem.id,
          name: elem.title || "",
          description: elem.description || "",
          embedCode: elem.url || "",
          groupId: elem.groupId || "",
          reportId: elem.reportId || "",
          isProtected: elem.isProtected,
          categories:
            elem.category.map((e) => ({
              id: e.id,
              name: e.name || "",
              description: e.description || "",
            })) || [],
        };
        dataArray.push(obj);
      });
    }

    return dataArray;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default visualizationApi;
